import {Component, OnDestroy} from '@angular/core';
import {NoticeService} from "../../../domain/notice/notice.service";
import {DatePipe} from "@angular/common";
import {FlexLayoutModule, MediaChange, MediaObserver} from "@ngbracket/ngx-layout";
import {MatDialog, MatDialogModule} from "@angular/material/dialog";
import {Subscription} from "rxjs";
import {InspectionService} from "../../../domain/inspection/inspection.service";
import {NGXLogger} from "ngx-logger";
import {Inspection} from "../../../domain/inspection/inspection";
import {InfoDialogComponent} from "../../../shared/dialog/info-dialog/info-dialog.component";

@Component({
  selector: 'app-main-notice',
  standalone: true,
  imports: [
    FlexLayoutModule,
    DatePipe,
    MatDialogModule
  ],
  templateUrl: './main-notice.component.html',
  providers: [NoticeService]
})
export class MainNoticeComponent implements OnDestroy {
  isMobile = false;
  irosNotice?: Inspection;
  analysisNotice?: Inspection;
  private readonly mediaWatcher: Subscription;

  constructor(private readonly log: NGXLogger,
              private readonly media: MediaObserver,
              private readonly inspectionService: InspectionService,
              private readonly matDialog: MatDialog) {
    this.mediaWatcher = this.media.asObservable()
      .subscribe((change: MediaChange[]) => {
        this.isMobile = change[0].mqAlias === 'xs';
      });

    // 점검 안내는 홈 본문과 독립적인 보조 정보이므로 새로고침 화면을 차단하지 않는다.
    this.inspectionService.getInspection(true)
      .subscribe(response => {
        this.irosNotice = response.iros ? new Inspection(response.iros) : undefined;
        this.analysisNotice = response.analysis ? new Inspection(response.analysis) : undefined;
      })
  }

  openNotice(notice: Inspection | any) {
    let content;
    if (notice.webContent) {
      content = this.isMobile ? notice.mobileContent : notice.webContent;
    } else {
      content = notice.getContent();
    }

    this.matDialog.open(InfoDialogComponent, {
      data: {
        title: notice.title,
        compactTitle: true,
        content: content.replaceAll("<br>", "\n").replaceAll(/(<([^>]+)>)/ig, '')
      }
    });
  }

  ngOnDestroy(): void {
    if (this.mediaWatcher) {
      this.mediaWatcher.unsubscribe();
    }
  }
}
